import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Card, List } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GenericCard } from "Pages/Project/Components/GenericCard";
import { I18N_NS } from "Config/i18n";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { userInfoStore } from "Stores/UserInfoStore";
import { observer } from "mobx-react";
import { withRouter, WithRouterProps } from "Components/General/WithRouter";

interface SupportListItem {
  title: string;
  link: string;
  icon: string;
}

interface SupportPageProps extends WithTranslation, WithRouterProps {}

export const SupportPage = withTranslation(I18N_NS.SUPPORT)(
  withRouter(
    observer(
      class extends React.Component<SupportPageProps> {
        supportInfo: SupportListItem[] = [
          {
            title: "+49 89 330 37 82-100",
            link: "tel:49893303782100",
            icon: "phone",
          },
          {
            title: "support@pmgnet.de",
            link: "mailto:support@pmgnet.de",
            icon: "envelope",
          },
        ];
        // tslint:disable-next-line:max-line-length
        supportMessage = `Our Customer Success Team can help you mondays-fridays from 8am-5pm CET`;

        renderListItem = (item: SupportListItem) => {
          const { t } = this.props;
          return (
            <List.Item>
              <List.Item.Meta
                title={
                  <>
                    <FontAwesomeIcon icon={["fal", item.icon as IconName]} />{" "}
                    <a href={item.link} target="_blank" rel="noopener noreferrer">
                      {t(item.title)}
                    </a>
                  </>
                }
              />
            </List.Item>
          );
        };

        renderHelpCenterArea = () => {
          return (
            <Card title={this.props.t("Help Center")} className="mb-2">
              <a
                href="https://pmgsupport.atlassian.net/servicedesk/customer/portals"
                target="_blank"
                rel="noopener noreferrer"
                title="PAVE Help Center"
                className="underline"
              >
                {this.props.t(
                  "Manuals, videos, contact options and information on updates in PAVE can be found in PAVE Help Center"
                )}
                <span className="ml-sm">
                  <FontAwesomeIcon icon={["far", "external-link"]} fixedWidth={true} size="sm" />
                </span>
              </a>
            </Card>
          );
        };

        render() {
          const { t, navigate } = this.props;
          const canSeePrivateStuff =
            userInfoStore.role !== "GUEST" && userInfoStore.role !== "BIDDER" && userInfoStore.status === "OK";
          return (
            <div className="dashboard">
              {canSeePrivateStuff ? (
                <div onClick={() => navigate("/dashboard")} className="detail-action mb-2" style={{ width: 190 }}>
                  <span className="detail-action-icon">
                    <FontAwesomeIcon icon={["far", "chevron-left"]} fixedWidth={true} size="sm" />
                  </span>
                  {t("Back to dashboard")}
                </div>
              ) : (
                <div onClick={() => navigate(-1)} className="detail-action mb-2" style={{ width: 190 }}>
                  <span className="detail-action-icon">
                    <FontAwesomeIcon icon={["far", "chevron-left"]} fixedWidth={true} size="sm" />
                  </span>
                  {t("Back to login")}
                </div>
              )}
              <GenericCard>
                <h1>{t("Help")}</h1>
                {this.renderHelpCenterArea()}
                <Card title={t("Customer Success Team")} className="mb-2">
                  <p className="mb-2">{t(this.supportMessage)} </p>
                  <p className="mb-2"> {t("Contact our Customer Success Team")}:</p>
                  <List itemLayout="horizontal" dataSource={this.supportInfo} renderItem={this.renderListItem} />
                </Card>
              </GenericCard>
            </div>
          );
        }
      }
    )
  )
);
